/**
 * config.ts — Configuración global de la plataforma InnovaAgent
 *
 * FUENTE DE VERDAD para constantes de infraestructura y dominio.
 *
 * ⚠️  IMPORTANTE PARA FUTUROS DESARROLLADORES:
 * Todas las URLs que referencien el dominio de la plataforma DEBEN
 * usar estas constantes. Nunca hardcodear 'innovagent.tech' directamente
 * en componentes o páginas.
 *
 * Cuando se implemente soporte de dominios propios por agente
 * (ej: orbe.com.mx apuntando a la plataforma), la lógica de resolución
 * de dominio se centralizará aquí y todos los componentes se beneficiarán
 * automáticamente sin cambios adicionales.
 */

// Dominio base de la plataforma
export const PLATFORM_DOMAIN = 'innovagent.tech'

// URL base del sitio principal
export const PLATFORM_URL = `https://${PLATFORM_DOMAIN}`

// URL base del dashboard
export const DASHBOARD_URL = `${PLATFORM_URL}/dashboard`

/**
 * Genera la URL pública del subdominio de un agente.
 * Usar siempre esta función en lugar de construir la URL manualmente.
 *
 * @param subdomain - El subdominio del agente (ej: 'juan-perez')
 * @returns URL completa del sitio del agente (ej: 'https://juan-perez.innovagent.tech')
 *
 * TODO: Cuando se implemente dominio propio por agente, esta función
 * deberá recibir también el campo `custom_domain` del agente y
 * retornar ese dominio si está configurado y activo.
 */
export const getAgentUrl = (subdomain: string): string => {
  return `https://${subdomain}.${PLATFORM_DOMAIN}`
}

/**
 * Genera la URL de una propiedad específica de un agente.
 *
 * @param subdomain - El subdominio del agente
 * @param seoTitle - El SEO title de la propiedad
 * @returns URL completa de la propiedad
 */
export const getPropertyUrl = (subdomain: string, seoTitle: string): string => {
  return `${getAgentUrl(subdomain)}/property/${seoTitle}`
}

// Emails de contacto de la plataforma
export const PLATFORM_EMAILS = {
  contacto: 'contacto@bdctech.com.mx',
  soporte: 'soporte@bdctech.com.mx',
  ventas: 'contacto@bdctech.com.mx',
}
